<template>
  <div class="home">
    <div class="out">
      <Header :fullHeader="true" :containerFluid="false"></Header>

      <section class="section">
        <div class="container">
          <h2 class="section__title mb-4 text-center">Что мы предлагаем?</h2>

          <div class="row justify-content-center">
            <div class="col-md-6">
              <p class="text-center font-">
                Удобная онлайн платформа для проверки своих знаний. Постоянно
                пополняющийся банк вопросов. Умный подбор тестов, исключающий
                повторы.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section class="section section--gray section-step" id="begin">
        <div class="container">
          <div class="row">
            <div class="col">
              <h2 class="section__title mb-4">Как начать?</h2>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-md-4 step-item p-5">
              <div class="step-item__number">
                1
              </div>
              <p>
                Зарегистрируйтесь на сервисе и перейдите в личный кабинет
              </p>
            </div>
            <div class="col-12 col-md-4 step-item p-5">
              <div class="step-item__number">
                2
              </div>
              <p>
                В личном кабинете нажмите
                <span class="text-warning">"Начать тест"</span> и выберите
                необходимую категорию теста.
              </p>
            </div>
            <div class="col-12 col-md-4 step-item p-5">
              <div class="step-item__number">
                3
              </div>
              <p>
                Переходите к тестированию. После прохождения в личном кабинете
                будет доступна вся информация о проверке.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section class="section section-price" id="tests">
        <div class="container">
          <h2 class="section__title mb-4">Тесты</h2>

          <div class="row">
            <div class="col-12 col-md-6 col-lg-4 mb-4 mb-lg-4">
              <!-- card -->
              <div class="e-card">
                <div class="e-card__header">
                  <h3 class="e-card__title">Контрольная работа</h3>
                </div>
                <div class="e-card__content">
                  <div class="e-card__price">
                    <!-- <div class="e-card__price-sym"><sup>₼</sup>5</div> -->
                    <div class="e-card__price-desc">
                      Контрольная работа по теме
                    </div>
                  </div>

                  <ul class="e-card__list">
                    <li>10 заданий</li>
                    <li>7 тестов</li>
                    <li>3 открытых вопросов</li>
                  </ul>
                </div>
                <div class="e-card__action center">
                  <router-link :to="{name: 'ExamBegin', params: {tab: 'Testwork', id: 2}}" class="e-btn">
                    Выбрать
                  </router-link>
                </div>
              </div>
              <!-- card -->
            </div>
            <div class="col-12 col-md-6 col-lg-4 mb-4 mb-lg-4">
              <!-- card -->
              <div class="e-card">
                <div class="e-card__header">
                  <h3 class="e-card__title">Итоговый</h3>
                </div>
                <div class="e-card__content">
                  <div class="e-card__price">
                    <!-- <div class="e-card__price-sym"><sup>₼</sup>25</div> -->
                    <div class="e-card__price-desc">Итоговый тест за год</div>
                  </div>

                  <ul class="e-card__list">
                    <li>30 заданий</li>
                    <li>20 тестов</li>
                    <li>10 открытых вопросов</li>
                  </ul>
                </div>
                <div class="e-card__action center">
                  <router-link to="exam/begin" class="e-btn">
                    Выбрать
                  </router-link>
                </div>
              </div>
              <!-- card -->
            </div>
            <div class="col-12 col-md-6 col-lg-4 mb-4 mb-lg-4">
              <!-- card -->
              <div class="e-card">
                <div class="e-card__header">
                  <h3 class="e-card__title">Вступительные</h3>
                </div>
                <div class="e-card__content">
                  <div class="e-card__price">
                    <!-- <div class="e-card__price-sym"><sup>₼</sup>30</div> -->
                    <div class="e-card__price-desc">
                      Подготовка к вступительным и выпускным экзаменам
                    </div>
                  </div>

                  <ul class="e-card__list">
                    <li>30 заданий</li>
                    <li>20 тестов</li>
                    <li>10 открытых вопросов</li>
                    <li>60 минут</li>
                  </ul>
                </div>
                <div class="e-card__action center">
                  <router-link to="exam/begin" class="e-btn">
                    Выбрать
                  </router-link>
                </div>
              </div>
              <!-- card -->
            </div>
          </div>
          <b-collapse id="collapse-2">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 mb-4 mb-lg-4">
                <!-- card -->
                <div class="e-card">
                  <div class="e-card__header">
                    <h3 class="e-card__title">Вступительные</h3>
                  </div>
                  <div class="e-card__content">
                    <div class="e-card__price">
                      <!-- <div class="e-card__price-sym"><sup>₼</sup>30</div> -->
                      <div class="e-card__price-desc">
                        Подготовка к вступительным и выпускным экзаменам
                      </div>
                    </div>

                    <ul class="e-card__list">
                      <li>param 1</li>
                      <li>param 2</li>
                      <li>param 3</li>
                      <li>param 4</li>
                    </ul>
                  </div>
                  <div class="e-card__action center">
                    <router-link to="exam/begin" class="e-btn">
                      Выбрать
                    </router-link>
                  </div>
                </div>
                <!-- card -->
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-4 mb-lg-4">
                <!-- card -->
                <div class="e-card">
                  <div class="e-card__header">
                    <h3 class="e-card__title">Вступительные</h3>
                  </div>
                  <div class="e-card__content">
                    <div class="e-card__price">
                      <!-- <div class="e-card__price-sym"><sup>₼</sup>30</div> -->
                      <div class="e-card__price-desc">
                        Подготовка к вступительным и выпускным экзаменам
                      </div>
                    </div>

                    <ul class="e-card__list">
                      <li>param 1</li>
                      <li>param 2</li>
                      <li>param 3</li>
                      <li>param 4</li>
                    </ul>
                  </div>
                  <div class="e-card__action center">
                    <router-link to="exam/begin" class="e-btn">
                      Выбрать
                    </router-link>
                  </div>
                </div>
                <!-- card -->
              </div>
            </div>
          </b-collapse>

          <div class="row">
            <div class="col pt-5 text-center pb-0">
              <b-button
                v-b-toggle="'collapse-2'"
                variant="default"
                class="btn btn-link"
                >Посмотреть все</b-button
              >
            </div>
          </div>
        </div>
      </section>

      <section class="section section--gray section-price">
        <div class="container">
          <h2 class="section__title text-center">Создать аккаунт</h2>
          <p class="text-center">
            Регистрация необходима для получения доступа к личному кабинету, из
            которого можно начать тестирование.
          </p>
          <b-row>
            <b-col class="text-center mt-3">
              <router-link
                :to="{ path: isLoggedIn ? '/dashboard' : '/register' }"
                class="e-btn"
              >
                Создать
              </router-link>
            </b-col>
          </b-row>
        </div>
      </section>

      <Footer />
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer.vue';

export default {
  name: 'Home',
  components: {
    Header,
    Footer
  },
  metaInfo() {
    return {
      title: this.metaTitle || 'Главная',
      titleTemplate: `%s. ${this.sortDesc || ''}`
    };
  },
  computed: {
    metaTitle() {
      return this.$store.getters.getSiteParams?.siteName;
    },
    sortDesc() {
      return this.$store.getters.getSiteParams?.shortDescription;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    user() {
      return this.$store.getters.user;
    }
  }
};
</script>
